"use strict";
require.config({
    baseUrl: STATIC_URL + "js/",
    paths : {
        jquery : 'lib/jquery',
        appquery : 'lib/appquery',
        bootstrap : 'lib/bootstrap.min',
        require : 'require/require',
        text : 'require/text',
        json : 'require/json',
        templates : '../templates',
        app : 'lib/app',
        panzoom : 'plugins/panzoom',
        snap : 'plugins/snap',
        fuse : 'plugins/fuse',
        astar : 'plugins/astar',
        dexie : 'plugins/dexie',
        toastr : 'plugins/toastr',
    },
    shim : {
        bootstrap : ['jquery'],
        panzoom : ['jquery'],
        snap : ['jquery'],
        astar : ['jquery'],
    },
    config: {
        text: {
            useXhr: function (url, protocol, hostname, port) {
                // allow cross-domain requests
                // remote server allows CORS
                return true;
            }
        }
    }
});

require(['jquery', 'app'], function($, App) {
    $(document).on('click', '.back', function(e) {
        e.preventDefault();
        App.page.back();
    });

    $(document).on('click', 'a[href^="#"]:not([data-toggle=collapse]),li[href^="#"]', function(e) {
        e.preventDefault();
        var that = $(this);
        var page = that.attr('href').slice(1);
        if(page) {
            App.page.render(page, that.data());
        }
    });
});

(function(){
    var defaultPages = ["login", "message", "spinner"];
    var defaultModules = defaultPages.map(function(name){
        return 'pages/' + name;
    }).concat(defaultPages.map(function(name) {
        return 'text!templates/' + name + '.html';
    }));

    require(["jquery", "bootstrap", "app"].concat(defaultModules) , function($, Bootstrap, App) {
        $(document).on('input change', '.listWithFilters .filters .field', function() {
            var that = $(this);
            var value = that.val();
            var key = that.attr('name');
            var container = that.closest('.listWithFilters');

            container.find('.listItem').addClass(key + 'hidden');
            var searchResults;
            if(!!value) {
                searchResults = container.find('[data-filter="' + key + '"]:icontains("' + value + '")').closest('.listItem');
                searchResults.removeClass(key + 'hidden');
            } else {
                searchResults = container.find('.listItem');
                searchResults.removeClass(key + 'hidden');
            }
            if(!searchResults.length) {
                container.find('.list .notFound').removeClass('hidden');
            }
            else {
                container.find('.list .notFound').addClass('hidden');
            }
        });

        $(document).on('click', '.closeCard', function() {
            $(this).closest('.card').remove();
        });

        App.init('admin', {
            menu : [
                {
                    name : 'Logout',
                    icon : 'sign-out',
                    handler  : function(e) {
                        e.preventDefault();
                        App.page.render('home', {mode : 'login'});
                        App.api.call("/auth.logout", $.noop, $.noop, {
                            onLogout : $.noop
                        });
                    }
                },
                {
                    name : 'Dashboard',
                    icon : 'home',
                    handler  : function(e) {
                        e.preventDefault();
                        App.page.resetHistory();
                        App.page.render('dashboard', App.global('retailer'));
                    }
                }
            ],
            onLogin : function(userData) {
               App.page.render('dashboard', userData.retailer);
            }
        });

        App.page.render('spinner', 'Loading resources...', true);
        App.database.get(['retailer_id', 'user'], function(data) {
            App.global(data);
            if(data.retailer_id) {
                App.api.call('/retailer.getDetails', {id : data.retailer_id}, function(response) {
                    App.page.render('dashboard', response);
                }, function(message) {
                    App.page.login({
                        message : message
                    });
                }, {
                    onLogout : function() {
                        App.page.render('home');
                    }
                });
            } else {
                App.page.render('home');
            }
        });
    });
})();
define("admin", function(){});

